import { useField } from 'react-final-form';
import { RadioButton } from '../RadioButton';

type RadioButtonFieldParams = {
  name: string,
  value: string,
  label: string,
  children?: React.ReactNode,
  onClick?: () => void,
};

const RadioButtonField = ({
  name,
  value,
  label,
  ...rest
}: RadioButtonFieldParams) => {
  const field = useField(name);
  const selected = field.input.value === value;
  return (
    <RadioButton
      onClick={() => field.input.onChange(value)}
      isActive={selected}
      {...rest}
    >
      {label}
    </RadioButton>
  );
};

export default RadioButtonField;
